import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Carousel } from '@pella/sash-framework';
import { contentstackClient } from '../../../utils/contentstack-client';
import { GET_ARTICLES_BY_TAXONOMY } from '../../../enums/contentstack-graphql';
import { isValidArray } from '../../utilities/validations';

import ArticleCard from '../article-card';

const ArticleSlider = ({ dynamic, className, ...other }) => {
	const filters = isValidArray(dynamic?.filter_tags) ? dynamic?.filter_tags?.map((filter) => ({ taxonomies: { filter_by: { term_in: filter?.split(', ') } } })) : [];
	const { data } = useQuery(GET_ARTICLES_BY_TAXONOMY, { client: contentstackClient, variables: { filters }, skip: !isValidArray(dynamic?.filter_tags) });

	if (!isValidArray(data?.all_articles?.items) && !isValidArray(dynamic?.manual_entries)) return null;

	return (
		<div
			className={`articleSlider relative ${className || ''}`}
			data-testid='article-slider'
			{...other}
		>
			<Carousel showArrows>
				{isValidArray(data?.all_articles?.items) &&
					data.all_articles.items.map((item, index) => (
						<ArticleCard
							key={index}
							data={item}
						/>
					))}
				{isValidArray(dynamic?.manual_entries) &&
					dynamic.manual_entries.map((item, index) => (
						<ArticleCard
							key={index}
							data={item}
						/>
					))}
			</Carousel>
		</div>
	);
};

ArticleSlider.propTypes = {
	data: PropTypes.object,
	dynamic: PropTypes.object,
	className: PropTypes.string,
};

export default ArticleSlider;
